// Fonte unica de verdade para o mapeamento das DEPs mostradas no radar da
// Ficha do Animal (RadarDEPs) e na Tabela Percentil (AnimaisPercentil).
// Cada entrada:
// - label: nome exibido (mesmo nome ja usado no antigo grafico de barras ChartD3)
// - raw: campo do valor bruto da DEP no objeto "caracteristicas" de um animal
//   (endpoint consultarDetalhesAnimalAvaliacaoGenetica) - usado so pelo radar.
// - top: campo do TOP% correspondente nesse mesmo objeto - usado so pelo radar.
// - percentil: campo equivalente na tabela de percentis por raca (endpoint
//   consultarTabelaPercentilPorRaca) - usado pelo radar (normalizacao) e pela
//   Tabela Percentil (uma coluna por DEP).
//
// So incluimos aqui as DEPs que ja foram conferidas contra dados reais nesta
// investigacao (batendo nome x campo x valor). A tabela de percentis por raca
// traz ~40 campos no total (ex: dpac, dpav, dpg, dalt, dmar, dacab, ded, des,
// dmd, dpd, dmac, dcar, dims, dipm, dframe, mgTe_CR/RE/CO/F1, ige, etc.) que
// NAO estao mapeados aqui - preferimos mostrar menos colunas com nome 100%
// correto a arriscar rotular errado uma DEP zootecnica.
export const DEPS_PERCENTIL = [
  { label: 'MGTe', raw: 'mgt', top: 'tmgt', percentil: 'mgt' },
  { label: 'DAOL', raw: 'ddaol', top: 'tdaol', percentil: 'daol' },
  { label: 'DPE450', raw: 'ddpE455', top: 'tdpE455', percentil: 'dpE450' },
  { label: 'DPE365', raw: 'ddpE365', top: 'tdpE365', percentil: 'dpE365' },
  { label: 'DSTAY', raw: 'ddstay', top: 'tdstay', percentil: 'dstay' },
  { label: 'DP450', raw: 'ddpP455', top: 'tdpP455', percentil: 'dP450' },
  { label: 'DP210', raw: 'ddpP240', top: 'tdpP240', percentil: 'dP210' },
  { label: 'MP210', raw: 'dmpP240', top: 'tmpP240', percentil: 'mP210' },
  { label: 'MP120', raw: 'dmpP120', top: 'tmpP120', percentil: 'mP120' },
  { label: 'D3P', raw: 'ddpP30', top: 'tdpP30', percentil: 'd3P' },
  { label: 'DIPP', raw: 'ddipp', top: 'tdipp', percentil: 'dipp' },
];

export default DEPS_PERCENTIL;
